import logger from '@/layers/support/monitoring/logger';
import { ProviderProfile } from '@/types/models';
import { NewProviderRequest } from '@/types/providers';
import { fetchWrapper } from '../utils/fetchWrapper';

const LOG_MODULE = 'FE [Presentation / Services / Health Providers]';

const API_URL = '/api/users/providers';

export const fetchProviderById = async (id: string): Promise<ProviderProfile> => {
  logger.debug(`${LOG_MODULE} fetchProviderById: begin`, { id });

  try {
    const result = await fetchWrapper.get<ProviderProfile>(`${API_URL}/${id}`);

    logger.debug(`${LOG_MODULE} fetchProviderById: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchProviderById`, { error });
    throw error;
  }
};

export const fetchProviderByUserId = async (id: string): Promise<ProviderProfile> => {
  logger.debug(`${LOG_MODULE} fetchProviderByUserId: begin`, { id });

  try {
    const result = await fetchWrapper.get<ProviderProfile>(`${API_URL}/user/${id}`);

    logger.debug(`${LOG_MODULE} fetchProviderByUserId: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchProviderByUserId`, { error });
    throw error;
  }
};

export const createProviderByUserId = async (
  provider: NewProviderRequest,
): Promise<ProviderProfile> => {
  logger.debug(`${LOG_MODULE} createProvider: begin`, { provider });

  try {
    const result = await fetchWrapper.put<ProviderProfile>(
      `${API_URL}/user/${provider.user_id}`,
      provider,
    );

    logger.debug(`${LOG_MODULE} createProvider: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} createProvider`, { error });
    throw error;
  }
};

export const submitProviderVerification = async (
  providerId: string,
  npi: string,
): Promise<void> => {
  logger.debug(`${LOG_MODULE} submitProviderVerification: begin`, {
    providerId,
    npi,
  });

  try {
    await fetchWrapper.put(`${API_URL}/${providerId}/verify`, { npi });
  } catch (error) {
    logger.error(`${LOG_MODULE} submitProviderVerification`, { error });
    throw error;
  }
};

export const updateProviderProfile = async (
  providerId: string,
  data: {
    npi?: string;
    medical_institution?: string;
    personal_info?: {
      first_name?: string;
      last_name?: string;
    };
    meta?: {
      npi?: string;
      medical_institution?: string;
      given_name?: string;
      family_name?: string;
      [key: string]: any;
    };
  },
): Promise<ProviderProfile> => {
  logger.debug(`${LOG_MODULE} updateProviderProfile: begin`, { providerId, data });

  try {
    const result = await fetchWrapper.put<ProviderProfile>(`${API_URL}/${providerId}`, data);

    logger.debug(`${LOG_MODULE} updateProviderProfile: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} updateProviderProfile`, { error });
    throw error;
  }
};
